import { useMutation, useQuery } from "@apollo/client";
// import moment from "moment";
import dayjs from "dayjs";
import { useCallback, useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { CREATE_SALE, GENERATE_INVOICE } from "../apollo/mutations";
import { LIST_PRODUCTS, SALE_DETAIL } from "../apollo/queries";
import closeModal from "../common/closeModal";
import { all_routes } from "../Router/all_routes";
import { showErrorToast } from "../utils";
import {
    downloadPDF,
    getSelectedStoreDetails,
    payloadValidator,
} from "../utils/helperFunctions";
import { showSwal } from "../utils/swal";

const defaultValues = {
    customer_id: "",
    warehouse_id: "",
    sale_date: dayjs(),
    sale_tax: "0",
    discount: "0",
    shipping: "0",
};

// const useCreateSale = (refetch, downloadInvoice, id) => {
const useCreateSale = () => {

    const { state } = useLocation()
    const navigate = useNavigate()

    const {
        control,
        handleSubmit,
        reset,
        watch,
        setValue,
        getValues,
        formState: { errors },
    } = useForm({ defaultValues });

    let customer_id = watch("customer_id")
    let warehouse_id = watch("warehouse_id")

    const [productArray, setProductArray] = useState([])

    const { data, loading: loading_sale } = useQuery(SALE_DETAIL, {
        variables: {
            getSaleId: state?.id,
        },
        skip: !state?.id,
        fetchPolicy: "network-only",
    });

    const { data: products_data } = useQuery(LIST_PRODUCTS, {
        variables: {
            storeId: getSelectedStoreDetails("id"),
            warehouseId: warehouse_id || null,
            customerId: customer_id || null,
        },
        skip: !customer_id || !warehouse_id,
        fetchPolicy: "network-only",
    });

    const [generateInvoice] = useMutation(GENERATE_INVOICE, {
        onCompleted: (data) => downloadPDF(data?.generateSalePDF?.data?.pdf, `${data?.generateSalePDF?.data?.invoice_no}`),
        onError: (err) => {
            console.error("Error generating PDF:", err.message);
        },
    });

    const [submit, { loading }] = useMutation(CREATE_SALE,
        {
            onCompleted: (res) => {
                reset(defaultValues);
                // refetch();
                // closeModal("add-sales-new");
                showSwal({
                    title: "Confirmation!",
                    text: `Sale created successfully for ${res?.createSale?.data?.customer?.full_name}. Invoice #${res?.createSale?.data?.invoice_no} is ready for download.`,
                    confirmButtonText: "Download Invoice",
                    cancelButtonText: "Ok",
                    showCancelButton: true,
                    onConfirm: () => {
                        downloadInvoice(res?.createSale?.data?.id)
                        navigate(all_routes.saleslist)
                    },
                    onCancel: () => {
                        navigate(all_routes.saleslist)
                    }
                })
            }
        }
    );

    useEffect(() => {

        console.log("jaskalksjdas", customer_id)

        if (!loading_sale && data?.getSale) {

            let sale_data = data?.getSale

            setValue("discount", sale_data?.discount)
            setValue("shipping", sale_data?.shipping)
            setValue("warehouse_id", sale_data?.warehouse.id)

        }

    }, [data, loading_sale])

    useEffect(() => {

        if (products_data && products_data?.listProduct && data && data?.getSale) {

            let sale_data = data?.getSale
            let products = products_data?.listProduct

            const product_ids = new Set(sale_data?.sale_items.map(item => item.product.id));
            const result = products.filter(item => product_ids.has(item.id));

            let temp = result.map(item => ({
                product_id: item?.id,
                productName: item?.name,
                images: item?.product?.images?.[0],
                quantity: sale_data?.sale_items?.find(i => i.product.id === item.id)?.quantity,
                price: item?.last_price ?? item.price,
            }))

            setProductArray(temp)

        }

    }, [products_data, data])

    useEffect(() => {
        if (!watch("sale_date")) {
            setValue("sale_date", dayjs().toDate());
        }
    }, [setValue, watch]);

    const downloadInvoice = useCallback((id) => {

        let payload = {
            variables: {
                generateSalePdfId: id,
            },
        };

        toast.promise(generateInvoice(payload), {
            pending: "Generating Invoice ...",
            success: "Invoice Generated Successfully",
        });

    }, []);

    const onAddQuotation = async (data) => {
        try {
            if (productArray?.length > 0) {
                const invalidProduct = productArray.find(
                    (item) =>
                        item.price == "" || item.price == "0" || item.price === undefined
                );

                if (invalidProduct) {
                    showErrorToast("Please enter a valid product price");
                    return;
                }

                const invalidQty = productArray.find(
                    (item) =>
                        item.quantity == "" ||
                        item.quantity == "0" ||
                        item.quantity === undefined
                );

                if (invalidQty) {
                    showErrorToast("Please enter a valid product quantity");
                    return;
                }

                const quotationDate = dayjs(data?.sale_date);
                if (!quotationDate.isValid()) {
                    showErrorToast("Invalid Date Selected");
                    return;
                }
                let payload = {
                    customer_id: data?.customer_id,
                    store_id: getSelectedStoreDetails("id"),
                    warehouse_id: data?.warehouse_id,
                    sale_date: quotationDate.format("MM-DD-YYYY"),
                    reference_no: data?.reference_no,
                    sale_tax: parseFloat(data?.sale_tax),
                    discount: parseFloat(data?.discount),
                    shipping: parseFloat(data?.shipping),
                    sale_products: productArray?.map((item) => ({
                        product_id: parseInt(item?.product_id),
                        quantity: parseInt(item?.quantity),
                        price: parseFloat(item?.price),
                    })),
                };
                await submit(payloadValidator(payload));

            } else {
                showErrorToast("Please Add Product");
            }
        } catch (error) {
            console.log("Mutation error:", error.message);
        }
    };

    const onCancel = () => {
        reset(defaultValues);
        closeModal("add-sales-new");
    };

    return {
        values: {
            control,
            errors,
            setValue,
            getValues,
            loading,
            selected_customer: watch("customer_id"),
            productArray,
            loading_sale
        },
        functions: {
            onSubmit: handleSubmit(onAddQuotation),
            onCancel,
            setProductArray
        },
    };
};

export default useCreateSale;
